import State from 'interfaces/state/State';

export const from$ = (state: State) => state.rating.from;
export const to$ = (state: State) => state.rating.to;
export const rating$ = (state: State) => state.rating.rating;
export const fromPulled$ = (state: State) => state.rating.fromPulled;
